import React, { useCallback, useState, useEffect } from 'react';
import { useQuery, useQueryClient, useMutation } from 'react-query';
import moment from 'moment';
import { Steps } from 'antd';
import srv from '../../../../services';
import { ContentWrapper } from '../../../_common';
import {
 ZoomInIcon,
 ZoomOutIcon,
 RegisteredIcon,
 ProccesingIcon,
 InWorkedIcon,
 ClosedIcon,
 CreatedIcon,
 AnswerIcon,
 QuestionIcon,
} from '../../../_assests';
import {
 Empty,
 Content,
 Appeal,
 AppealData,
 AppealParam,
 AppealContent,
 AppealZoom,
 Messages,
 Message,
 MessageHead,
 MessageDate,
 MessageText,
 ContractZoom,
 TitleStep,
 StepBlockDis,
 StepBlockDone,
} from './AppealsQuestion.styled';
import DataGrid from '../../../Shared/DataGrid/DataGrid';
import AppealModel from '../../../Shared/models/AppealModel';
import { AppealsColumns } from '../../../Shared/columns/AppealsColumns';
import { AppealsDetailsColumns } from '../../../Shared/columns/AppealsDetailsColumns';
import { Checkbox } from '@material-ui/core';
import SnackBar from '../../../Shared/SnackBar';
import { RootState } from '../../../../store/store';
import { shallowEqual, useSelector } from 'react-redux';

const { Step } = Steps;

export default function AppealsQuestion() {
 const { appealsQuestion, isLoading, error, maximized, onMaximize } =
  useAppealsQuestion();
 const [currentStep, setCurrentStep] = useState(null);
 const [mainColumns, setMainColumns] = useState(AppealsColumns());
 const [detailColumns, setDetailColumns] = useState(AppealsDetailsColumns());
 const [showGrid, setShowGrid] = useState(false);
 const [appealData, setAppealData] = useState<AppealModel[]>([]);

 const configData = useSelector(
  (state: RootState) => state.config,
  shallowEqual,
 );

 useEffect(() => {
  const appealsColumns = AppealsColumns();
  const detailColumns = AppealsDetailsColumns();

  setMainColumns(appealsColumns);
  setDetailColumns(detailColumns);

  srv.getShowFeedbackAisTableView().then((response) => {
   if (response && response.data) {
    setShowGrid(response.data === '0' ? false : true);
   }
  });
 }, []);

 useEffect(() => {
  srv.getShowFeedbackAisTableView().then((response) => {
   if (response && response.data) {
    setShowGrid(response.data === '0' ? false : true);
   }
  });
 }, [showGrid]);

 useEffect(() => {
  let appealArray: AppealModel[] = [];

  appealsQuestion.forEach((item) => {
   const create = item.eventsHystory.filter((x) => x.eventName === 'Создано');
   const inPreparation = item.eventsHystory.filter(
    (x) => x.eventName === 'В обработке',
   );
   const registration = item.eventsHystory.filter(
    (x) => x.eventName === 'Зарегистрировано',
   );
   const inProcess = item.eventsHystory.filter(
    (x) => x.eventName === 'Принято в работу',
   );
   const closed = item.eventsHystory.filter((x) => x.eventName === 'Закрыто');

   const appeal: AppealModel = {
    requestNumber: item.requestNumber,
    questionMessage: item.message,
    questionCreateDate: item.createDate,
    responseMessage: item.responseMessage,
    responseDate: item.responseDate,

    responseCreate:
     create && create.length > 0 && create[0].eventName
      ? create[0].eventName
      : '',
    responseCreateDate:
     create && create.length > 0 && create[0].createDate
      ? create[0].createDate
      : '',

    responseInPreparation:
     inPreparation && inPreparation.length > 0 && inPreparation[0].eventName
      ? inPreparation[0].eventName
      : '',
    responseInPreparationDate:
     inPreparation && inPreparation.length > 0 && inPreparation[0].createDate
      ? inPreparation[0].createDate
      : '',

    responseRegistration:
     registration && registration.length > 0 && registration[0].eventName
      ? registration[0].eventName
      : '',
    responseRegistrationDate:
     registration && registration.length > 0 && registration[0].createDate
      ? registration[0].createDate
      : '',

    responseInProcess:
     inProcess && inProcess.length > 0 && inProcess[0].eventName
      ? inProcess[0].eventName
      : '',
    responseInProcessDate:
     inProcess && inProcess.length > 0 && inProcess[0].createDate
      ? inProcess[0].createDate
      : '',

    responseClosed:
     closed && closed.length > 0 && closed[0].eventName
      ? closed[0].eventName
      : '',
    responseClosedDate:
     closed && closed.length > 0 && closed[0].createDate
      ? closed[0].createDate
      : '',
   };

   appealArray.push(appeal);

   item.eventsHystory.forEach((event, idx) => {
    if (event.createDate !== null) setCurrentStep(idx);
   });
  });

  setAppealData(appealArray);
 }, [appealsQuestion]);

 const showGridChangeHandle = (value: React.ChangeEvent<HTMLInputElement>) => {
  const payload = {
   newValue: `${Number(value?.target?.checked)}`,
  };

  srv.setShowFeedbackAisTableView(payload).then(() => {
   setShowGrid(!showGrid);
  });
 };

 return (
  <ContentWrapper isLoading={isLoading} error={error}>
   {!appealsQuestion?.length ? (
    <Empty>У Вас пока нет отправленных обращений.</Empty>
   ) : (
    <Content>
     <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
      <div style={{ marginLeft: '10px' }}>
       <label
        style={{
         marginRight: '5px',
         top: '20px !important',
         color: 'black',
         fontWeight: 600,
        }}
       >
        Показать в табличном виде
       </label>
       <Checkbox
        checked={showGrid}
        style={{
         height: '40px',
         width: '40px',
         color: '#ffb614',
        }}
        onChange={showGridChangeHandle}
       />
      </div>
      <div style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
       {showGrid && (
        <DataGrid
         columns={mainColumns?.columns ? mainColumns.columns : []}
         detailColumns={detailColumns?.columns ? detailColumns.columns : []}
         rows={appealsQuestion}
         detailsRows={appealData}
         detailsType={'appealQuestions'}
         take={20}
         page={1}
         pagination={true}
        />
       )}
      </div>

      <div style={{ display: 'flex', flexDirection: 'row' }}>
       {!showGrid &&
        appealsQuestion.map((appeal) => {
         const date = appeal.eventsHystory.map((item) => {
          return item.createDate;
         });
         const status = appeal.eventsHystory.map((item) => {
          return item.eventState;
         });
         return (
          <Appeal
           key={appeal.id}
           maximized={maximized === appeal.id}
           featured={appeal.isNew}
          >
           <ContractZoom onClick={() => onMaximize(appeal)}>
            {maximized === appeal.id ? <ZoomOutIcon /> : <ZoomInIcon />}
           </ContractZoom>
           <AppealData onClick={() => onMaximize(appeal)}>
            <AppealParam cols>
             <span>
              <u>№ обращения</u>
              {appeal.requestNumber ? (
               <b>{appeal.requestNumber}</b>
              ) : (
               'На регистрации'
              )}
             </span>

             <span>
              <u>Обращение</u>
              Вопрос
             </span>
            </AppealParam>

            <AppealParam>
             <u>№ договора</u>
             <b>{appeal.contractNumber}</b>
            </AppealParam>

            <AppealParam>
             <span>
              <u>Дата создания</u>
              {moment(appeal.createDate).format('DD.MM.YYYY')}
             </span>
            </AppealParam>
            <AppealParam>
             <span>
              <u>Дата и время регистрации обращения</u>
              {appeal.requestDate !== null
               ? moment(appeal.requestDate).format('DD.MM.YYYY HH:mm')
               : 'На регистрации'}
             </span>
            </AppealParam>
            <AppealParam cols={appeal.isNew}>
             <span>
              <u>Статус</u>
              {appeal.state}
             </span>

             {appeal.isNew && (
              <span>
               <u>Новое сообщение</u>
               <strong>{configData.companyShortName}</strong>
              </span>
             )}
            </AppealParam>
           </AppealData>

           {maximized === appeal.id && (
            <AppealContent>
             <Messages>
              <Message>
               <MessageHead>
                <MessageDate>
                 Вы {moment(appeal.createDate).format('DD.MM.YYYY')}
                </MessageDate>
                <QuestionIcon />
               </MessageHead>
               <MessageText>{appeal.message}</MessageText>
              </Message>

              {!!appeal?.responseMessage && (
               <Message answer>
                <MessageHead>
                 <AnswerIcon />
                 <MessageDate>
                  АО «ЭК «Восток»{' '}
                  {moment(appeal.responseDate || undefined).format(
                   'DD.MM.YYYY',
                  )}
                 </MessageDate>
                </MessageHead>

                {!!appeal.responseMessage && (
                 <MessageText>{appeal.responseMessage}</MessageText>
                )}
               </Message>
              )}
             </Messages>
             <Steps current={currentStep}>
              <Step
               status={status[0] === 'Выполняется' ? 'finish' : 'wait'}
               title={
                <TitleStep>
                 <span>Создано</span>
                 {moment(appeal.createDate).format('DD.MM.YYYY')}
                </TitleStep>
               }
               icon={
                status[0] === 'Выполняется' ? (
                 <CreatedIcon />
                ) : (
                 <StepBlockDone>
                  <CreatedIcon />
                 </StepBlockDone>
                )
               }
              />
              <Step
               status={status[1] === 'Выполняется' ? 'finish' : 'wait'}
               title={
                <TitleStep>
                 <span>В обработке</span>
                 {date[1] !== null
                  ? moment(date[1]).format('DD.MM.YYYY')
                  : undefined}
                </TitleStep>
               }
               icon={
                status[1] === 'Выполняется' ? (
                 <ProccesingIcon />
                ) : status[1] === 'В ожидании' ? (
                 <StepBlockDis>
                  <ProccesingIcon />
                 </StepBlockDis>
                ) : (
                 <StepBlockDone>
                  <ProccesingIcon />
                 </StepBlockDone>
                )
               }
              />
              <Step
               status={status[2] === 'Выполняется' ? 'finish' : 'wait'}
               title={
                <TitleStep>
                 <span>Зарегистрировано</span>
                 {date[2] !== null
                  ? moment(date[2]).format('DD.MM.YYYY')
                  : undefined}
                </TitleStep>
               }
               icon={
                status[2] === 'Выполняется' ? (
                 <RegisteredIcon />
                ) : status[2] === 'В ожидании' ? (
                 <StepBlockDis>
                  <RegisteredIcon />
                 </StepBlockDis>
                ) : (
                 <StepBlockDone>
                  <RegisteredIcon />
                 </StepBlockDone>
                )
               }
              />
              <Step
               status={status[3] === 'Выполняется' ? 'finish' : 'wait'}
               title={
                <TitleStep>
                 <span>В работе</span>
                 {date[3] !== null
                  ? moment(date[3]).format('DD.MM.YYYY')
                  : undefined}
                </TitleStep>
               }
               icon={
                status[3] === 'Выполняется' ? (
                 <InWorkedIcon />
                ) : status[3] === 'В ожидании' ? (
                 <StepBlockDis>
                  <InWorkedIcon />
                 </StepBlockDis>
                ) : (
                 <StepBlockDone>
                  <InWorkedIcon />
                 </StepBlockDone>
                )
               }
              />
              <Step
               status={status[4] === 'Выполняется' ? 'finish' : 'wait'}
               title={
                <TitleStep>
                 <span>Закрыто</span>
                 {date[4] !== null
                  ? moment(date[4]).format('DD.MM.YYYY')
                  : undefined}
                </TitleStep>
               }
               icon={
                status[4] === 'Выполняется' ? (
                 <ClosedIcon />
                ) : status[4] === 'В ожидании' ? (
                 <StepBlockDis>
                  <ClosedIcon />
                 </StepBlockDis>
                ) : (
                 <StepBlockDone>
                  <ClosedIcon />
                 </StepBlockDone>
                )
               }
              />
             </Steps>
            </AppealContent>
           )}

           <AppealZoom onClick={() => onMaximize(appeal)} />
          </Appeal>
         );
        })}
      </div>
     </div>
    </Content>
   )}

   <SnackBar vertical="top" horizontal="center" />
  </ContentWrapper>
 );
}

function useAppealsQuestion() {
 const queryClient = useQueryClient();

 const {
  data: appealsQuestion,
  isFetching,
  error,
 } = useQuery<Models.AppealQuestion[]>(
  'appealsQuestion',
  srv.getAppealsQuestion,
  {
   initialData: [],
  },
 );

 const { mutate: markRead } = useMutation(
  (id: number) => srv.markRead('aisAppeals', id),
  {
   onSuccess: () => {
    queryClient.refetchQueries('feature');
    queryClient.refetchQueries('appealsQuestion');
   },
  },
 );

 const [maximized, setMaximized] = useState(null);

 const onMaximize = useCallback(
  (appeal: Models.AppealQuestion) => {
   if (appeal.isNew) {
    markRead(appeal.id);
   }
   if (maximized === appeal.id) {
    setMaximized(null);
   } else {
    setMaximized(appeal.id);
   }
  },
  [markRead, maximized],
 );
 return {
  appealsQuestion,
  isLoading: isFetching && !appealsQuestion?.length,
  error,
  maximized,
  onMaximize,
 };
}
